import React, { Component } from "react";
import ProvidersTable from './ProvidersTable';
import MobileProvidersTable from './MobileProvidersTable';
import $ from 'jquery';

class ZipcodeForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            displayErrors: false,
            value: '',
            validZipCode: true
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        if (!event.currentTarget.checkValidity()) {
            this.setState({ displayErrors: true });
            return;
        }

        this.setState({ displayErrors: false });
        let self = this;
        let url = `https://channellocator.cminternalcontrol.com/api/channellocator?zipcode=${self.state.value}`;
        // let url = `https://apichannellocator.crownmediadev.com/api/ChannelLocator?zipcode=${self.state.value}`;
        $.get(url, function (data) {
            self.setState({ data: data.result });
            // self.setState({ data: data });
        });
    }

    handleChange(event) {
        let isValidZipcode = this.validateZipCode(event.target.value)
        if (event.target.value.length !== 5) {
            this.setState({
                data: []
            })
        }

        if (event.target.value.length === 5) {
            this.getChannels(event.target.value);
        }

        this.setState({
            value: event.target.value,
            validZipCode: isValidZipcode
        })
    }

    validateZipCode(zipcode) {
        let isValidZipcode = (/(^\d{5}$)|(^\d{5}-\d{4}$)/).test(zipcode);
        if (zipcode.length === 0 || isValidZipcode) {
            return true
        } else {
             return false;
        }
    }

    getChannels(value) {
        let self = this;
        let url = `https://channellocator.cminternalcontrol.com/api/channellocator?zipcode=${value}`;
        // let url = `https://apichannellocator.crownmediadev.com/api/ChannelLocator?zipcode=${value}`;
        $.get(url, function (data) {
            self.setState({ data: data.result });
            // self.setState({ data: data });
        });
    }

    render() {
        const { displayErrors } = this.state;
        return (
            <div className="container">
                <div className="">
                    <h3>Enter your zip code to find your local channel number or <a href="#/unavailable">click here</a> to make a channel request</h3>
                    <form noValidate className="zip-form" onSubmit={this.handleSubmit}>
                        <div className={displayErrors ? 'displayErrors form-group' : 'form-group'}>
                            <label htmlFor="inp" className="inp">
                                <input type="text" id="inp" value={this.state.value} onChange={this.handleChange} placeholder="&nbsp;" required />
                                <span className="label">Zipcode</span>
                                <span className="border"></span>
                            </label>
                            {this.state.validZipCode ? '' : <p style={{ color: 'red'}}>Please enter a valid 5 digit zip code</p>}
                        </div>
                    </form>
                    <div>
                        <ProvidersTable channel={this.props.match.params.channel ? this.props.match.params.channel : "hc"} data={this.state.data} value={this.state.value}/>
                        <MobileProvidersTable channel={this.props.match.params.channel ? this.props.match.params.channel : "hc"} data={this.state.data} />
                    </div>
                </div>
            </div>
        );
    }
}

export default ZipcodeForm;


// WEBPACK FOOTER //
// ./src/components/ZipcodeForm.js